import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Paper from 'material-ui/Paper';
import { Row, Col } from 'react-flexbox-grid';

import convert from 'utils/dateTools';
import pallet from 'constants/colors';
import styles from 'styles/AppraisalList';
import StatusIcon from './StatusIcon';

const AppraisalItem = ({ appraisal, isManager, onClick }) => {
  const manDue = new Date(appraisal.ManagerDueDate);
  manDue.setHours(23, 59, 59);
  const manStat = appraisal.ManagerStatus;

  const empDue = new Date(appraisal.EmployeeDueDate);
  empDue.setHours(23, 59, 59);
  const empStat = appraisal.EmployeeStatus;

  const finDue = new Date(appraisal.FinalAppraisalDate);
  finDue.setHours(23, 59, 59);
  const finStat = appraisal.FinalStatus;

  const dueDate = isManager ? manDue : empDue;
  const stat = isManager ? manStat : empStat;

  const managerLock = ((empStat === 2 && manStat === 2) || finDue.getTime() < Date.now())
    ? false
    : (manStat === 2 && (empDue.getTime() > Date.now()));

  const notManagerLock = (finStat === 2 || finDue.getTime() < Date.now())
    ? false
    : ((empStat === 2) || (empDue.getTime() < Date.now()));

  const lock = isManager ? managerLock : notManagerLock;

  /* eslint no-nested-ternary: 0 */
  const status = lock ? 3 : finStat === 2 ? 4 : -1;

  const statusMsg = finStat === 2
    ? <span style={{ color: pallet.successColor }}><FormattedMessage id="appraisal.finished" /></span>
    : finDue.getTime() < Date.now()
      ? <span style={{ color: pallet.warningColor }}><FormattedMessage id="appraisal.submit.fail" /></span>
      : dueDate.getTime() < Date.now() && stat !== 2
        ? <span style={{ color: pallet.errorColor }}><FormattedMessage id="appraisal.answer.fail" /></span>
        : stat === 2
        && <span style={{ color: pallet.successColor }}><FormattedMessage id="appraisal.answer" /></span>;


  return (
    <Paper
      key={appraisal.PMAppraisalID}
      onClick={() => onClick(appraisal.PMAppraisalID)}
      style={{ ...styles.appraisal, cursor: 'pointer' }}
    >
      <div style={styles.date}>
        <span style={styles.title}><StatusIcon type={status} />{appraisal.PMFormTitle}</span>
        <div>
          <FormattedMessage id="expires" />
          <span>{` ${convert(empDue)}`}</span>
        </div>
      </div>
      <Row style={styles.content}>
        <Col xs={12} sm={6} md={5}>
          <span style={styles.subInfo}>
            <FormattedMessage id="appraisal.employee" />
          </span>
          <span style={styles.info}>{status && <StatusIcon type={appraisal.EmployeeStatus} />}{appraisal.EmployeeName}</span>
        </Col>
        <Col xs={12} sm={6} md={5}>
          <span style={styles.subInfo}>
            <FormattedMessage id="appraisal.manager" />
          </span>
          <span style={styles.info}><StatusIcon type={appraisal.ManagerStatus} />{appraisal.ManagerName}</span>
        </Col>
        <Col xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'end', justifyContent: 'end' }}>
          <div style={{ ...styles.info }}>{statusMsg}</div>
        </Col>
      </Row>
    </Paper>
  );
};

AppraisalItem.propTypes = {
  appraisal: PropTypes.object.isRequired,
  isManager: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default AppraisalItem;



// WEBPACK FOOTER //
// ./src/components/AppraisalItem.js